import axios from 'axios'

//axios.defaults.baseURL = 'http://127.0.0.1:3100';
axios.defaults.baseURL = 'https://venezuela-stats.onrender.com';
